import * as React from "react";
import { Field } from "formik";
import { TextField } from "office-ui-fabric-react";

export const CustomTextField: React.FC<{
  name: string;
  type?: "number" | "text" | "password";
  label?: string;
  onBlurFunc?: Function;
  disabled?: boolean;
  multiline?: boolean;
  placeholder?: string;
  description?: string;
  autoAdjustHeight?: boolean;
  resizable?: boolean;
}> = ({ name, type, label, onBlurFunc, disabled, placeholder, multiline, description, autoAdjustHeight, resizable }) => {
  return (
    <Field name={name}>
      {({
        field, // { name, value, onChange, onBlur }
        form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
        meta,
      }: any) => (
        <div className={multiline ? "custom-multiline-textfield" : "custom-textfield"}>
          <TextField
            type={type || "text"}
            label={label || ""}
            tabIndex="-1"
            errorMessage={meta.touched && meta.error && meta.error}
            {...field}
            onBlur={(event) => {
              field.onBlur(event);
              onBlurFunc && onBlurFunc(field.value, field.name);
            }}
            autoFocus={false}
            multiline={multiline}
            placeholder={placeholder || ""}
            disabled={disabled}
            description={description}
            autoAdjustHeight={autoAdjustHeight || false}
            resizable={resizable || false}
          />
          {/* {meta.touched && meta.error && (
          <div className="error">{meta.error}</div>
        )} */}
        </div>
      )}
    </Field>
  );
};
